/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyLimit from './pharmacy-limit';
import PharmacyLimitDetail from './pharmacy-limit-detail';
import PharmacyLimitUpdate from './pharmacy-limit-update';
import PharmacyLimitDeleteDialog from './pharmacy-limit-delete-dialog';

const PharmacyLimitRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyLimit />} />
    <Route path="new" element={<PharmacyLimitUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyLimitDetail />} />
      <Route path="edit" element={<PharmacyLimitUpdate />} />
      <Route path="delete" element={<PharmacyLimitDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyLimitRoutes;
